import { useEffect, useState } from "react";
import API from "../lib/api";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Lightning } from "@phosphor-icons/react";

export default function PlatformZapierCard() {
  const [url, setUrl] = useState("");
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    API.get("/platform/settings/zapier").then(({ data }) => { setUrl(data.invite_url || ""); setStatus(data.status || ""); }).catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await API.put("/platform/settings/zapier", { invite_url: url, status });
      setUrl(data.invite_url || ""); setStatus(data.status || "");
      toast.success("Zapier settings saved");
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); }
    finally { setBusy(false); }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-3" data-testid="platform-zapier-card">
      <div>
        <h2 className="text-base font-semibold flex items-center gap-2"><Lightning size={18} weight="duotone" className="text-orange-500" /> Zapier app</h2>
        <p className="text-xs text-muted-foreground mt-1">
          The Fixlr Zapier app lives in <code>/app/zapier</code> in this repository. Publish it from your Zapier developer account (<code>zapier login</code>, <code>zapier push</code>), then paste the
          private invite link (Zapier → Sharing) or, once approved, the public listing URL. Tenants see it on their Integrations page.
        </p>
      </div>
      <div className="grid gap-3 sm:grid-cols-[1fr_180px]">
        <div>
          <Label className="text-xs font-semibold">Invite / listing URL</Label>
          <Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://zapier.com/developer/public-invite/…" className="mt-1" data-testid="platform-zapier-url-input" />
        </div>
        <div>
          <Label className="text-xs font-semibold">Status note</Label>
          <Input value={status} onChange={(e) => setStatus(e.target.value)} placeholder="e.g. Private beta" className="mt-1" data-testid="platform-zapier-status-input" />
        </div>
      </div>
      <Button size="sm" onClick={save} disabled={busy} data-testid="platform-zapier-save-btn">{busy ? "Saving…" : "Save"}</Button>
    </div>
  );
}
